import React, { useState } from 'react';
import {
  Typography,
  Checkbox,
  FormControlLabel,
  OutlinedInput,
  IconButton,
  Button,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { useSetupStyles } from './style';

interface ChannelItem {
  channelName: string;
  channelType: string;
  enabled: boolean;
  isCustom: boolean;
}

interface ChannelsStepProps {
  channels: ChannelItem[];
  setChannels: React.Dispatch<React.SetStateAction<ChannelItem[]>>;
}

const DEFAULT_CHANNELS: ChannelItem[] = [
  { channelName: 'General', channelType: 'Posts', enabled: true, isCustom: false },
  { channelName: 'Announcements', channelType: 'Posts', enabled: true, isCustom: false },
  { channelName: 'Events', channelType: 'Posts', enabled: true, isCustom: false },
];

export { DEFAULT_CHANNELS };

export default function ChannelsStep({ channels, setChannels }: ChannelsStepProps) {
  const classes = useSetupStyles();
  const [newChannelName, setNewChannelName] = useState('');

  const toggleChannel = (index: number) => {
    setChannels((prev) =>
      prev.map((ch, i) => (i === index ? { ...ch, enabled: !ch.enabled } : ch))
    );
  };

  const removeChannel = (index: number) => {
    setChannels((prev) => prev.filter((_, i) => i !== index));
  };

  const addChannel = () => {
    const trimmed = newChannelName.trim();
    if (!trimmed) return;
    if (channels.some((ch) => ch.channelName.toLowerCase() === trimmed.toLowerCase())) return;
    setChannels((prev) => [
      ...prev,
      { channelName: trimmed, channelType: 'Posts', enabled: true, isCustom: true },
    ]);
    setNewChannelName('');
  };

  return (
    <div className={classes.stepContent}>
      <Typography variant="body1" className={classes.formLabel} style={{ marginBottom: 12 }}>
        Channels
      </Typography>
      <Typography variant="body2" style={{ marginBottom: 16, color: '#666' }}>
        Choose which channels to create. You can always add more later.
      </Typography>

      {channels.map((ch, index) => (
        <div key={index} className={classes.channelRow}>
          <FormControlLabel
            control={
              <Checkbox
                checked={ch.enabled}
                onChange={() => toggleChannel(index)}
                color="primary"
              />
            }
            label={`${ch.channelName} (${ch.channelType})`}
          />
          {ch.isCustom && (
            <IconButton size="small" onClick={() => removeChannel(index)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          )}
        </div>
      ))}

      <div className={classes.addChannelRow}>
        <OutlinedInput
          placeholder="New channel name"
          value={newChannelName}
          onChange={(e) => setNewChannelName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              addChannel();
            }
          }}
          className={classes.inputStyle}
          style={{ flex: 1 }}
          inputProps={{ maxLength: 50 }}
        />
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={addChannel}
          startIcon={<AddIcon />}
        >
          Add
        </Button>
      </div>
    </div>
  );
}
